import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useImpersonationStore } from "@/features/ops/store/impersonation-store";

/**
 * Persistent banner shown app-wide while a staff operator is impersonating
 * another user. "Return to yourself" restores the operator's own session and
 * closes the audited server-side session.
 */
export function ImpersonationBanner() {
  const isImpersonating = useImpersonationStore((s) => s.isImpersonating);
  const targetName = useImpersonationStore((s) => s.targetName);
  const end = useImpersonationStore((s) => s.end);
  const [returning, setReturning] = useState(false);
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleReturn = async () => {
    setReturning(true);
    try {
      await end();
      navigate("/admin/ops");
    } finally {
      setReturning(false);
    }
  };

  return (
    <div
      role="alert"
      className="bg-primary text-primary-foreground shadow-card mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg px-4 py-3 text-sm font-medium"
    >
      <span>
        You are viewing as <strong>{targetName}</strong>.
      </span>
      <Button size="sm" variant="secondary" onClick={handleReturn} disabled={returning}>
        {returning ? "Returning…" : "Return to yourself"}
      </Button>
    </div>
  );
}
